/**
 * Webpage to display requested Dataset
 */
import accounting from 'accounting';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import L from "leaflet";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { renderToStaticMarkup } from "react-dom/server"
import antenna from "../img/arrow.svg"
import omniAntenna from "../img/omniArrow.svg"
import { Link } from "react-router-dom";
import "leaflet-rotatedmarker"
import * as excelJS from "exceljs"
import { saveAs } from "file-saver"
import mhz from "../files/Anlage_3_-_Frequenzzuteilungs-Antrag_3700-3800_MHz.xlsx"
import moment from "moment"
import cosineGradient from 'cosine-gradient';
import loader from "../img/loader.gif";
import loading_icon from "../img/loading_icon.gif";
import Plotly from 'plotly.js-dist';
import polylabel from "polylabel";

// import exampleCampus from '../files/campus.json';
// import exampleLogistik from '../files/logistiklager.json';

require('moment-precise-range-plugin')


const ExampleCampus = ({ example_id }) => {
    accounting.settings = {
        currency: {
            symbol: "€",
            format: "%v %s",
            decimal: ",",
            thousand: ".",
            precision: 2
        },
        number: {
            precision: 0,
            thousand: ",",
            decimal: "."
        }
    }


    var min_rem = -120;
    var max_rem = -30;

    var rect_rad = 10;

    var result = {}
    var map = undefined;
    var layerControl = undefined;
    var rem_layer = undefined;
    var ant_layer = undefined;
    const [priorities, setPriorities] = useState([])


    // Heatmap kann hier angepasst werden. Farbschemen sind hier zu finden: dev.thi.ng/gradients/
    var scheme =
        [[0.828, 0.5, 0],
        [0.808, 0.5, 0],
        [0.228, 0.5, 0],
        [1.098, 0.588, 0]
        ];

    var gradient = cosineGradient(scheme);

    const getExampleData = async ({ id }) => {
        let module;

        if (id === 1) {
            module = await import('../files/campus.json');
        }
        else {
            module = await import('../files/logistiklager.json');
        }
        const exampleData = module.default;

        // const chosen_result = exampleCampus[0];
        console.log(exampleData)
        return exampleData
    }

    const createImage = () => {

        document.getElementById("remWrapper").style.display = "block";

        const extra = 30;
        const c = document.createElement("canvas");
        c.width = document.getElementById("remWrapper").offsetWidth;
        c.height = 50;
        const ctx = c.getContext("2d");
        const t = 10;
        const step_width = 1 / (c.width / (t + 1));
        for (let i = 0; i <= 1; i = i + step_width) {
            ctx.fillStyle = gradToRGB(gradient(i));
            ctx.fillRect(extra + t * (i / step_width), 0, t, 25);
        }

        ctx.fillStyle = "black";
        ctx.font = "15px Arial";
        ctx.fillText(min_rem + " dBm", 0, 40);
        ctx.fillText(max_rem + " dBm", 1 / step_width * t, 40);
        document.getElementById("remLegend").src = c.toDataURL();
    };
    const calculateCentroid = (poly) => {
        let pts = []
        poly.forEach((p) => {
            pts.push([p.lat, p.lng])
        })
        const p = polylabel([pts], .000005);
        return L.latLng(p[0], p[1]);
    }

    useEffect(() => {
        var answer = {}
        var json = {}


        getExampleData({ id: example_id })
            .then((exampleData) => {
                answer = exampleData
                json = JSON.parse(answer.data)
                result = JSON.parse(answer.result)
                const buildings = json.buildings
                const customAntennas = json.customAntennas
                document.getElementById("retry").onclick = () => {
                    delete json.customAntennas
                    delete json.buildings
                    localStorage.setItem("json", JSON.stringify(json))
                    localStorage.setItem("polygon", JSON.stringify(outerPolygon.getLatLngs()[0]))
                    localStorage.setItem("buildings", JSON.stringify(buildings))
                    localStorage.setItem("customAntennas", JSON.stringify(customAntennas))
                }
                document.getElementById("area").innerHTML = json.area
                document.getElementById("a1").innerHTML = json.a1
                document.getElementById("a2").innerHTML = json.a2

                document.getElementById("frequency").innerHTML = json.frequency
                document.getElementById("B").innerHTML = json.bandwidth === "auto" ? (result == null ? "auto" : result.bandwidth) : json.bandwidth;
                document.getElementById("blocksize").innerHTML = json.bandwidth === "auto" ? (result == null ? "auto" : result.blocksize) : json.blocksize;
                document.getElementById("t").innerHTML = json.time[0] + " - " + json.time[1];
                document.getElementById("model").innerHTML = json.model;
                document.getElementById("baseStations").innerHTML = json.baseStations;
                document.getElementById("uplink-table").innerHTML = json.datarateUpLink;
                document.getElementById("downlink-table").innerHTML = json.datarateDownLink;

                document.getElementById("loader").style.display = "none"
                document.getElementById("disabler").style.display = "flex"
                document.getElementById("citation-text").style.display = "flex"
                document.getElementById("assumptions-text").style.display = "flex"
                document.getElementById("datasources-text").style.display = "flex"

                setPriorities(json.priorities)
                let dates = [moment(parseDate(json.time[0])), moment(parseDate(json.time[1])).add(1, "days")];
                let diff = moment.preciseDiff(dates[0], dates[1], true)
                let timeString = "Laufzeit: ("
                let numberElements = (diff.years !== 0 ? 1 : 0) + (diff.days !== 0 ? 1 : 0) + (diff.months !== 0 ? 1 : 0)
                if (diff.years === 1) {
                    timeString += diff.years + " Jahr"
                } else if (diff.years !== 0) {
                    timeString += diff.years + " Jahre"
                }
                if (numberElements === 3) {
                    timeString += ", "
                } else if (numberElements === 2 && diff.years !== 0) {
                    timeString += " und "
                }
                if (diff.months === 1) {
                    timeString += diff.months + " Monat"
                } else if (diff.months !== 0) {
                    timeString += diff.months + " Monate"
                }
                if (numberElements > 1 && diff.months !== 0 && diff.days !== 0) {
                    timeString += " und "
                }
                if (diff.days === 1) {
                    timeString += diff.days + " Tag"
                } else if (diff.days !== 0) {
                    timeString += diff.days + " Tage"
                }
                timeString += ") "
                document.getElementById("time").innerHTML = timeString


                var chosenFreq = json.frequency
                var freqFactor = -1
                if (chosenFreq === "3,7-3,8 GHz") {
                    freqFactor = 5
                }
                if (chosenFreq === "26 GHz") {
                    freqFactor = 0.63
                }
                let months = diff.months
                if (diff.days > 0) {
                    months += 1;
                }
                if (result != null) {
                    let partial = (Math.round((1000 + result.bandwidth * 1 * freqFactor * (((6 * json.a1) / 100) * json.area + (json.a2 / 100) * json.area)) * 100) / 100) * (months / 12);
                    json.price = diff.years === 0 ? accounting.formatMoney(partial) : accounting.formatMoney(partial + Math.round((1000 + result.bandwidth * diff.years * freqFactor * (((6 * json.a1) / 100) * json.area + (json.a2 / 100) * json.area)) * 100) / 100)
                }
                document.getElementById("kosten").innerHTML = json.price;

                document.getElementById("KUNZ-button").className = "d-print-none"
                if (diff.years === 0 && diff.months === 0) {
                    document.getElementById("KUNZ-button").style.visibility = "visible"
                } else {
                    document.getElementById("KUNZ-button").style.visibility = "hidden"
                }
                //Setting up map
                let outerPolygon = L.polygon(json.polygon, { color: 'red', fill: false })
                map = L.map('map', {
                    center: [0, 0],
                    zoom: 0,
                });
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    minZoom: 6,
                    maxNativeZoom: 18,
                    maxZoom: 20,
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                }).addTo(map);
                map.addLayer(outerPolygon)
                var buildingLayer = L.layerGroup().addTo(map);
                if (json.buildings.length !== 0) {
                    json.buildings.forEach((building, index) => {
                        const centroid = calculateCentroid(building.polygon)
                        var tooltip = L.tooltip({ className: "polygon-tooltip" })
                            .setContent("Höhe: " + building.height)
                        let poly = L.polygon(building.polygon, {
                            color: 'grey',
                            fill: true,
                        }).bindTooltip(tooltip).addTo(buildingLayer)
                        tooltip.on('add', function (e) {
                            tooltip.setLatLng(centroid)
                        })
                        poly.index = index;
                        poly.setStyle({
                            color: json.buildings[index].selected ? "red" : "grey"
                        });
                    })
                    layerControl = addToLayerControl(layerControl, map, buildingLayer, "Gebäude");
                }
                var customAntennaLayer = L.layerGroup().addTo(map);
                if (json.customAntennas.length !== 0) {
                    json.customAntennas.forEach((antenna, index) => {
                        let marker = L.marker(antenna.coords);
                        marker.bindTooltip(antenna.name).addTo(customAntennaLayer)
                    })
                    layerControl = addToLayerControl(layerControl, map, customAntennaLayer, "Antennenpositionen");
                }
                map.fitBounds(outerPolygon.getBounds())
                var prio_layer = L.layerGroup().addTo(map);
                if (json["priorities"] !== undefined) {
                    json["priorities"].forEach((priority) => {
                        let p = L.polygon(priority["polygon"], {
                            color: "#f0ffff",
                            fill: true,
                            fillOpacity: 0.7
                        }).addTo(prio_layer)
                        p.bindTooltip(priority["title"], {
                            className: 'polygon-tooltip'
                        });
                        priority.id = L.stamp(p)
                    })

                    layerControl = addToLayerControl(layerControl, map, prio_layer, "Anwendungsgebiet");
                }
                // p.bindTooltip("#" + m.id + " " + m.model, {
                //     permanent: true,
                //     className: 'polygon-tooltip'
                // });
                //reload localStorage
                //setup for status
                if (answer.status === 2) {
                    document.getElementById("status-text").innerHTML = " Netzplanung in Bearbeitung... (Schritt 2/3: REM Berechnung) ";
                    document.getElementById("status-info").innerHTML = ""
                } else if (answer.status === 3) {
                    document.getElementById("status-text").innerHTML = " Netzplanung in Bearbeitung... (Schritt 3/3: Automatisierte Netzplanung) ";
                    document.getElementById("status-info").innerHTML = ""
                } else if (answer.status === 10) {
                    document.getElementById("status-light").style.backgroundColor = "red"
                    document.getElementById("status-text").innerHTML = " Fehler: Es wurden zu viele Antennenstandorte ausgewählt.";
                    document.getElementById("status-info").innerHTML = " Kontaktieren Sie <a href='mailto:campusnetzplanerpro.kn.etit@tu-dortmund.de'>campusnetzplanerpro.kn.etit@tu-dortmund.de</a> für individuelle Absprachen oder versuchen Sie es erneut mit weniger Standorten. ";
                    document.getElementById("calculatingImg").style.visibility = "hidden";
                    // document.getElementById("retry").style.display = "inline-flex";
                    document.getElementById("antenna_calculating").style.display = "none";
                } else if (answer.status === 1) {

                    var all_results = result.results
                    var num_results = all_results.length
                    var num_areas = all_results[0].coverage.length
                    // console.log(all_results)

                    var chosen_result_idx = num_results - 1;

                    var result_chooser = document.getElementById("result_chooser");

                    var xData = [];
                    var applicationCovData = [];
                    var generalCovData = [];
                    for (var j = 0; j < num_areas; j++) {
                        var coverage = []
                        for (var i = 0; i < num_results; i++) {
                            coverage.push(all_results[i].coverage[j])
                            xData.push(i + 1);
                            generalCovData.push(all_results[i].general_coverage[j])
                        }
                        applicationCovData.push(coverage);
                    }
                    for (i = 0; i < num_results; i++) {
                        var option = document.createElement("option");
                        option.text = "Anzahl Basisstationen: " + (i + 1) + "  ---  Abdeckung mit Zieldatenrate: " + all_results[i].coverage + " %";
                        result_chooser.add(option);
                    }
                    var plotlyLines = []
                    var plotlyNames = []
                    var colors = ["red", "blue", "green", "grey", "orange", "pink"]
                    json.priorities.forEach(p => {
                        plotlyNames.push(p.title)
                    })
                    // if(plotlyNames.length< plotlyLines){
                    plotlyNames.push("Basisversorgung")
                    // }
                    applicationCovData.forEach((d, index) => {
                        var tmp_color = colors[index % colors.length]

                        if (plotlyNames[index] == "Basisversorgung")
                            tmp_color = "black"

                        plotlyLines.push(
                            {
                                x: xData,
                                y: d,
                                type: 'scatter',
                                mode: 'lines+markers',
                                name: plotlyNames[index],
                                legend: { x: 0, y: 100 },
                                line: { color: tmp_color },//%length(colors)]},
                            }
                        )
                    })

                    const container = document.getElementById('chartContainer');
                    Plotly.newPlot(container, plotlyLines, {
                        width: 650,
                        height: 507,
                        title: 'Abdeckung über Anzahl Basisstationen',
                        xaxis: { title: 'Anzahl Basisstationen', tickmode: "linear", tick0: 1, dtick: 1 },
                        yaxis: { title: 'Abdeckung [%]' },
                        legend: { x: 0.16, y: 100, orientation: "h" },
                        margin: { t: 100, b: 100 }

                    });

                    container.style.display = "inline-flex";
                    document.getElementById("chartTitle").style.display = "inline-flex";
                    document.getElementById("mapTitle").style.display = "inline-flex";
                    document.getElementById("mapTitleEmpty").style.display = "none";

                    result_chooser.selectedIndex = chosen_result_idx;
                    result_chooser.style.display = "inline-flex";

                    document.getElementById("status-light").style.backgroundColor = "green"
                    document.getElementById("status-text").innerHTML = " Netzplanung erfolgreich abgeschlossen."
                    document.getElementById("calculatingImg").style.visibility = "hidden";
                    // document.getElementById("retry").style.display = "inline-flex";
                    document.getElementById("status-info").innerHTML = ""
                    document.getElementById("print").style.display = "inline-flex"
                    document.getElementById("antenna_calculating").style.display = "none";
                    document.getElementById("print").onclick = function () {
                        const container = document.getElementById('chartContainer');
                        container.style.display = 'block';

                        const img = document.getElementById('remLegend');
                        img.style.display = 'block';
                        img.style.width = "500px";
                        img.style.height = "auto";

                        // Neue kleine Größe
                        Plotly.relayout(container, {
                            width: 500,
                            height: 400
                        }).then(() => {
                            setTimeout(() => {
                                window.print();

                                // Nach dem Drucken zurück zur Originalgröße
                                Plotly.relayout(container, {
                                    width: 650,
                                    height: 507
                                });

                                img.style.width = "auto";
                                img.style.height = "auto";
                            }, 100);
                        });

                        // window.print()
                    };

                    result_chooser.onchange = function () {
                        choose_result()
                    };


                    choose_result();

                    // TODO: FIXME: BNetzA JSON Test
                    /*
                    var bnetza = answer.bnetza;
                    document.getElementById("bnetza").style.display = "inline-flex"
                    //document.getElementById("bnetza").style.visibility = "visible";
                    document.getElementById("bnetza").onclick = function() {
                        var tab = window.open('about:blank', '_blank');
                        tab.document.write("<pre>"+JSON.stringify(bnetza, null, 2)+"</pre>");
                    }; */

                } else if (answer.status === -1) {
                    document.getElementById("status-light").style.backgroundColor = "red"
                    document.getElementById("status-text").innerHTML = " Fehler: Netzplanung konnte nicht abgeschlossen werden."
                    document.getElementById("status-info").innerHTML = "Womöglich sind Anpassungen an den Anwendungsanforderungen notwendig, z.B. eine geringere Zieldatenrate oder eine Eingrenzung des Anwenwendungsgebietes."
                    document.getElementById("calculatingImg").style.visibility = "hidden";
                    // document.getElementById("retry").style.display = "inline-flex";
                    document.getElementById("antenna_calculating").style.display = "none";

                }
                //display of models
                let vertices = findUnique(json.polygon)
                document.getElementById("application").addEventListener("click", function () {
                    fetch(mhz,
                        {
                            method: 'GET'
                        }).then((response) => response.blob())
                        .then((blob) => {
                            var reader = new FileReader()
                            reader.readAsArrayBuffer(blob)
                            const workbook = new excelJS.Workbook()
                            reader.onload = (e) => {
                                workbook.xlsx.load(e.target.result)
                                    .then(function () {
                                        var chosen_result_idx = document.getElementById("result_chooser").selectedIndex;
                                        var chosen_result = result.results[chosen_result_idx]
                                        var sheet = workbook.getWorksheet(1)
                                        const percentArea = json.area * json.a1 / 100
                                        sheet.getCell("B:27").value = percentArea
                                        sheet.getCell("B:28").value = Math.abs(json.area - percentArea)
                                        sheet.getCell("B:30").value = 3800
                                        sheet.getCell("B:31").value = result.bandwidth
                                        sheet.getCell("B:32").value = json.time[1]
                                        sheet.getCell("B:34").font = {
                                            size: 9
                                        }
                                        sheet.getCell("B:34").value = "Bitte beachten Sie, dass Senderausgangsleistung und Dämpfung von der jeweiligen Installation abhängig sind (z.B. Antennenkabellänge, Antennengewinn etc.). Auch kann Ihre Antennenspezifikation von den hier eingetragenen Werten abweichen. Bitte achten Sie auf die korrekte Eintragung der Werte!"
                                        var p = 39;
                                        vertices.forEach(m => {
                                            sheet.getCell("B:" + p).value = Math.round(m[1] * 100000) / 100000
                                            sheet.getCell("C:" + p).value = Math.round(m[0] * 100000) / 100000
                                            p++
                                        })
                                        sheet.getCell("B:" + p).value = Math.round(vertices[0][1] * 100000) / 100000
                                        sheet.getCell("C:" + p).value = Math.round(vertices[0][0] * 100000) / 100000

                                        var as = 3
                                        let antennas = chosen_result.antenna
                                        antennas.forEach(a => {
                                            let sheetToClone = workbook.getWorksheet(11)
                                            let copySheet = workbook.addWorksheet("temp")
                                            copySheet.model = sheetToClone.model
                                            if (as < 10) {
                                                copySheet.name = "Station_00" + (as - 2)
                                            } else {
                                                copySheet.name = "Station_0" + (as - 2)
                                            }
                                            copySheet.getCell("B:3").value = (as - 2)
                                            copySheet.getCell("B:6").value = "Gebiet_" + (as - 2)
                                            copySheet.getCell("B:14").value = 3800 - (result.bandwidth / 2)
                                            copySheet.getCell("B:16").value = result.bandwidth
                                            copySheet.getCell("B:17").value = a.azimuth === -1 ? a.eirp : String(a.eirp) + "- Antennengewinn"
                                            copySheet.getCell("B:19").value = 0
                                            copySheet.getCell("B:20").value = "nein"
                                            copySheet.getCell("B:27").value = a.angle === 360 ? '360' : a.angle
                                            copySheet.getCell("B:28").value = a.angle === 360 ? '360' : a.angle
                                            copySheet.getCell("B:29").value = 0
                                            copySheet.getCell("B:30").value = "D - Dual"
                                            copySheet.getCell("B:31").value = a.azimuth === -1 ? 0 : "Antennengewinn eintragen"
                                            copySheet.getCell("B:32").value = a.height
                                            copySheet.getCell("B:33").value = a.azimuth === -1 ? '0' : a.azimuth
                                            copySheet.getCell("B:34").value = a.tilt

                                            copySheet.getCell("B:37").value = Math.round(a.position.lng * 100000) / 100000
                                            copySheet.getCell("C:37").value = Math.round(a.position.lat * 100000) / 100000
                                            as++

                                        })
                                        workbook.removeWorksheet(11)
                                        workbook.removeWorksheet(26)

                                        workbook.xlsx.writeBuffer().then(function (buffer) {
                                            const blob = new Blob([buffer], { type: "application/xlsx" })
                                            saveAs(blob, "antrag_bnetza_anlage-3.xlsx")
                                        })
                                    })
                            }
                        })
                })

            })

    }, [])

    function parseDate(input) {
        var parts = input.match(/(\d+)/g);
        // note parts[1]-1
        return new Date(parts[2], parts[0] - 1, parts[1]);
    }

    function choose_result() {

        var chosen_result_idx = document.getElementById("result_chooser").selectedIndex;
        var chosen_result = result.results[chosen_result_idx]

        //document.getElementById("coverage").innerHTML = chosen_result.coverage;
        //document.getElementById("coverageGeneral").innerHTML = chosen_result.general_coverage;

        if (ant_layer !== undefined) {
            map.removeLayer(ant_layer);
            layerControl = removeFromLayerControl(layerControl, ant_layer);
        }
        if (rem_layer !== undefined) {
            map.removeLayer(rem_layer);
            layerControl = removeFromLayerControl(layerControl, rem_layer);
        }

        var antennaIcon = L.icon({
            className: "leaflet-data-marker",
            iconUrl: antenna,
            iconAnchor: [3.75, 12.5],
            iconSize: [30, 25],
        });
        var omniIcon = L.icon({
            className: "leaflet-data-marker",
            iconUrl: omniAntenna,
            iconSize: [50, 50],
        });

        let rem = chosen_result.rem
        if (rem !== null) {
            createImage();
            let points = JSON.parse(rem)
            let coords = points["xy"]

            let powers = points["power"]

            let rectangles = [];


            for (const [key, value] of Object.entries(coords)) {

                let xy = value[0]

                let bounds = L.latLng([xy[1], xy[0]]).toBounds(rect_rad);
                var rect = L.rectangle(bounds, {
                    fillColor: getColorMap(powers[key]),
                    color: "#000",
                    opacity: 0,
                    fillOpacity: 0.7
                });

                rectangles.push(rect);

            }

            rem_layer = L.layerGroup(rectangles).addTo(map);
            layerControl = addToLayerControl(layerControl, map, rem_layer, "Radio Environmental Map (REM)");

        }


        let antennas = chosen_result.antenna
        let ant_icons = []
        antennas.forEach(m => {
            let ant_icon;
            if (m.azimuth === -1) {
                ant_icon = L.marker([m.position.lat, m.position.lng], {
                    icon: omniIcon,
                })
            } else {
                ant_icon = L.marker([m.position.lat, m.position.lng], {
                    icon: antennaIcon,
                    rotationAngle: m.azimuth
                })
            }
            ant_icons.push(ant_icon);
        })
        ant_layer = L.layerGroup(ant_icons).addTo(map);
        addToLayerControl(layerControl, map, ant_layer, "Antennen");

        document.getElementById("antennaTableBody").innerHTML = renderToStaticMarkup(antennas.map(function (row, i) {
            return (
                <tr key={i}>
                    <td>{row.position.lat + "\n" + row.position.lng}</td>
                    <td>{row.height?.toFixed(2)}</td>
                    <td>{row.eirp}</td>
                    <td>{row.azimuth === -1 ? '360' : row.azimuth}</td>
                    <td>{row.tilt}</td>
                    <td>{row.angle === 360 ? '360' : row.angle}</td>
                </tr>
            );
        }
        ));
        document.getElementById("antennaTable").style.visibility = "visible";
        document.getElementById("application").style.display = "inline-flex";


    }

    function findUnique(polygon) {
        let jsonSet = new Set()
        polygon.forEach(m => {
            if (!jsonSet.has(JSON.stringify([m.lat, m.lng]))) {
                jsonSet.add(JSON.stringify([m.lat, m.lng]))
            }
        })
        jsonSet = [...jsonSet]
        return jsonSet.map((x) => {
            return JSON.parse(x)
        })
    }

    function getColorMap(power) {

        var mapped = (power - min_rem) / (max_rem - min_rem);

        var c = gradient(mapped);
        var cssColor = gradToRGB(c);
        return cssColor

    }

    function gradToRGB(c) {

        var rgb = [255 * c[0] | 0, 255 * c[1] | 0, 255 * c[2] | 0];
        var cssColor = "rgb(" + rgb.join(",") + ")";

        return cssColor

    }

    function addToLayerControl(layerControl, map, layerGroup, layerName) {

        if (layerControl === undefined) {
            layerControl = L.control.layers().addTo(map);
        }
        layerControl.addOverlay(layerGroup, layerName);

        return layerControl;

    }

    function removeFromLayerControl(layerControl, layerGroup) {
        layerControl.removeLayer(layerGroup);
        return layerControl;
    }

    const renderTooltip = (props) => (
        <Tooltip id={"hover-tooltip"} className={"d-print-none"} {...props}>
            Da der eingetragene Nutzungszeitraum unter einen Monat liegt, wird eine Kurzzeitzuteilung angenommen. Für
            nähere Informationen, klicken sie hier: <a target={"_blank"}
                href={"https://www.bundesnetzagentur.de/DE/Fachthemen/Telekommunikation/Frequenzen/SpezielleAnwendungen/Kurzzeitzuteilungen/start.html"}
                rel="noreferrer">KUNZ</a>
        </Tooltip>
    );
    return (<div id={"container"} className={"container headerMargin"}>
        <div className={'container flex justify-content-center'}><img id={'loader'} alt={"calculating"} src={loading_icon} style={{ width: "300px", marginBottom: '52vh' }} /></div>
        <div id={"disabler"} className={"row"} style={{ display: "none" }}>
            <div className={"col"}>
                <span className={"mb-1"} id={"chartTitle"} style={{ display: "none", fontWeight: "bold" }}>Vergleich bestmöglicher Deployments für unterschiedliche Basisstationsanzahlen</span>
                <div id={"chartContainer"}
                    className={"mb-1 align-middle rounded-3 border-dark border border-2 small align-items-center justify-content-center"}
                    style={{ display: "none" }}></div>
                <span className={"mb-1"} style={{ fontWeight: "bold" }}>Allgemeine Informationen</span>
                <table className={"rounded-3 border-dark border border-2 table small"} style={{ marginTop: "" }}>
                    <tbody>
                        <tr>
                            <th className={"align-middle"} scope={"row"}>Frequenzbereich:</th>
                            <td className={"align-middle"} style={{ textAlign: "right" }} id={"frequency"} />
                        </tr>
                        <tr>
                            <th className={"align-middle"} scope={"row"} style={{ border: "0px" }}>Bandbreite [MHz]:<br />
                            </th>
                            <td className={"align-middle"} style={{ border: "0px", textAlign: "right" }} id={"B"} />
                        </tr>
                        <tr>
                            <th className={"align-middle"} scope={"row"} style={{ fontWeight: "normal" }}>Blockgröße [MHz]
                                (als
                                Schrittweite der Bandbreite):
                            </th>
                            <td style={{ textAlign: "right" }} id={"blocksize"} />
                        </tr>
                        <tr>
                            <th className={"align-middle"} scope={"row"}>
                                <div style={{ display: "inline" }} id={"time"}>Laufzeit:</div>
                                <OverlayTrigger placement={"top"} delay={{ show: 250, hide: 400 }} trigger={"click"}
                                    overlay={renderTooltip}>
                                    <Button id={"KUNZ-button"} variant={"link"} style={{
                                        visibility: "hidden",
                                        backgroundColor: "inherit",
                                        border: "none"
                                    }}><FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "orange" }} /></Button>
                                </OverlayTrigger>

                            </th>
                            <td style={{ textAlign: "right" }} className={"align-middle"} id={"t"} />
                        </tr>
                        <tr>
                            <th className={"align-middle"}>Fläche [km<sup>2</sup>]:</th>
                            <td className={"align-middle"} style={{ textAlign: "right" }}>
                                <p className={"d-inline"} id={"area"} />
                            </td>
                        </tr>
                        <tr>
                            <th className={"align-middle"}><span
                                title={"Vgl. Angaben des Statistischen Bundesamtes und des Umweltbundesamtes zur Flächennutzung, abrufbar unter www.umweltbundesamt.de / „Struktur der Flächennutzung“."}>Anteil
                                Siedlungs- und Verkehrsfläche [%]:</span></th>
                            <td className={"align-middle"} style={{ textAlign: "right" }} id={"a1"} />
                        </tr>
                        <tr>
                            <th className={"align-middle"}><span
                                title={"Vgl. Angaben des Statistischen Bundesamtes und des Umweltbundesamtes zur Flächennutzung, abrufbar unter www.umweltbundesamt.de / „Struktur der Flächennutzung“."}>Anteil
                                Andere Flächen [%]:</span></th>
                            <td className={"align-middle"} style={{ textAlign: "right" }} id={"a2"} />
                        </tr>
                        <tr>
                            <th className={"align-middle"}>Frequenzzuteilungsgebühr:</th>
                            <td className={"align-middle"} style={{ textAlign: "right" }} id={"kosten"}>
                            </td>
                        </tr>
                        <tr>
                            <th className={"align-middle text-center"} style={{ borderBottom: "1px white" }}
                                colSpan="3">Zieldatenraten (Anwendungsanforderung)
                                [MBit/s]
                            </th>
                        </tr>
                        <tr>
                            <td colSpan="3">
                                <table style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left" }}>Anwendung</th>
                                            <th style={{ textAlign: "left" }}>Übertragungsrichtung</th>
                                            <th style={{ textAlign: "right" }}>Datenrate [MBit/s]</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Basisversorgung</td>
                                            <td style={{ textAlign: "left" }}>Uplink</td>
                                            <td id={"uplink-table"} style={{ textAlign: "right" }}>20</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td style={{ textAlign: "left" }}>Downlink</td>
                                            <td id={"downlink-table"} style={{ textAlign: "right" }}>5</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="3" style={{ padding: "0", textAlign: "center" }}>
                                                <hr className={"my-1"} style={{ border: "1px solid #ccc" }} />
                                            </td>
                                        </tr>
                                        {priorities.map((anwendung, index) => (
                                            <tr key={index}>
                                                <td>{anwendung.title}</td>
                                                <td style={{ textAlign: "left" }}>{anwendung.direction}</td>
                                                <td style={{ textAlign: "right" }}>{anwendung.datarate}</td>
                                            </tr>
                                        ))
                                        }
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <th className={"align-middle"}>Kanalmodell:</th>
                            <td className={"align-middle"} style={{ textAlign: "right" }}>
                                <p className={"d-inline"} id={"model"} />
                            </td>
                        </tr>
                        <tr>
                            <th className={"align-middle"}>Max. Anzahl Basisstationen:</th>
                            <td className={"align-middle"} style={{ textAlign: "right" }}>
                                <p className={"d-inline"} id={"baseStations"} />
                            </td>
                        </tr>

                    </tbody>
                </table>

                <div className={"status"}>
                    <div className={"fs-4 fw-bold pt-1"}>
                        Auftragsstatus:
                    </div>
                    <div id={"status"}>
                        <div id={"status-light"} style={{ backgroundColor: "orange" }} className={"circle"} />
                        <div id={"status-text"} className={"ps-1 pb-2 fs-6"}
                            style={{ display: "inline-flex" }}> Netzplanung
                            in Bearbeitung... (Schritt 1/3: Warten auf freien Slot)
                        </div>
                        <img alt={"calculating"} src={loader} id={"calculatingImg"} style={{ visibility: "visible" }} />
                        <div id={"status-info"} className={"ps-1 pb-2 fs-6 fs-6"} style={{ display: "d-flex" }}> </div>
                    </div>
                    <div>
                        <Link id={"retry"} to={"/safe"} className={"ms-2 fs-5 btn btn-dark"} style={{ display: "none" }}>Neustarten</Link>
                        <button id={"print"} style={{ display: "none" }} className={"ms-2 fs-5 btn btn-dark"}>Drucken
                        </button>
                        <button id={"application"} className={"ms-2 fs-5 btn btn-dark"} style={{ display: "none" }}>Excel
                            Antrag
                        </button>
                        <button id={"bnetza"} className={"ms-2 fs-5 btn btn-dark"} style={{ display: "none" }}>Online
                            Antrag
                            (Test)
                        </button>
                    </div>

                </div>

                <div id={"warning-text"} className={"ps-1 mb-2"}
                    style={{ fontSize: "small", display: "inline-flex" }}> Wichtiger Hinweis: Der Campusnetzplaner Pro
                    befindet sich noch in Entwicklung. Die hier berechneten Ergebnisse sind ohne Gewähr und sollten
                    überprüft werden.
                </div>

            </div>
            <div className={"col"}>
                <span className={"mb-1"} id={"mapTitleEmpty"} style={{ fontWeight: "bold" }}>Kartenansicht</span>
                <span className={"mb-1"} id={"mapTitle"} style={{ display: "none", fontWeight: "bold" }}>Netzplanungsergebnis für gewählte Anzahl Basisstationen</span>
                <select name="Anzahl Basisstationen" className={"form-select mb-3"} id={"result_chooser"}
                    style={{ display: "none" }}></select>
                <div className={"rounded-3 border-dark border border-2 mb-2"} style={{ height: "400px" }} id={"map"} />
                <div className="mx-auto mb-1" style={{ display: "none" }} id={"remWrapper"}><img className={""}
                    id={"remLegend"}
                    alt="Heatmap Legend" />
                </div>

                <span className={"mb-1"} style={{ fontWeight: "bold" }}>Antennenstandorte und -Konfigurationen</span>
                <span className={"mb-1"} id={"antenna_calculating"} style={{ visibility: "visible" }}><br />In Berechnung...<img
                    alt={"calculating"} src={loader} /></span>
                <table className={"rounded-3 border-dark border border-2 table small"} id={"antennaTable"}
                    style={{ visibility: "hidden" }}>
                    <thead>
                        <tr>
                            <th>Antennenposition</th>
                            <th>Höhe</th>
                            <th>EIRP [dBm]</th>
                            <th>Azimuth</th>
                            <th>Tilt</th>
                            <th>Öffnungswinkel</th>
                        </tr>
                    </thead>
                    <tbody id={"antennaTableBody"}>
                    </tbody>
                </table>

            </div>
        </div>
        <div id={"citation-text"} className={"ps-1 mb-2 mt-3"}
            style={{ fontSize: "small", display: "none", textAlign: "left" }}> {/*//"inline-flex"}}>*/}
            <div style={{ width: '150px' }}>Basierend auf:<br /></div>
            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                <li style={{ marginLeft: '23px', textIndent: '-23px' }}><span style={{ display: 'inline', textAlign: 'left' }}>[1]:&nbsp;</span>
                    C. Bektas, S. Böcker, B. Sliwa and C. Wietfeld, <a
                        href={'https://cni.etit.tu-dortmund.de/institute/news/details/rapid-network-planning-of-temporary-private-5g-networks-with-unsupervised-machine-learning-15603/'}
                        target={"_blank"} rel="noreferrer">"Rapid Network Planning of Temporary Private 5G Networks
                        with Unsupervised Machine Learning,"</a> 2021 IEEE 94th Vehicular Technology Conference
                    (VTC2021-Fall), 2021
                </li>
                <li style={{ marginLeft: '23px', textIndent: '-23px' }}><span style={{ display: 'inline', textAlign: 'left' }}>[2]:&nbsp;</span>
                    C. Bektas, S. Böcker, and C. Wietfeld, <a
                        href={'https://cni.etit.tu-dortmund.de/institute/news/details/the-cost-of-uncertainty-impact-of-overprovisioning-on-the-dimensioning-of-machine-learning-based-network-slicing-23790/'}
                        target={"_blank"} rel="noreferrer">"The Cost of Uncertainty: Impact of Overprovisioning on
                        the Dimensioning of Machine Learning-based Network Slicing,"</a> 2022 IEEE Future Networks
                    World Forum (FNWF), 2022
                </li>
                <li style={{ marginLeft: '23px', textIndent: '-23px' }}><span style={{ display: 'inline', textAlign: 'left' }}>[3]:&nbsp;</span>
                    M. Geis, C. Bektas, S. Böcker, C. Wietfeld, <a
                        href={'https://cni.etit.tu-dortmund.de/newsdetail/ai-driven-planning-of-private-networks-for-shared-operator-models-42286/'}
                        target={"_blank"} rel="noreferrer">"AI-driven Planning of Private Networks for Shared Operator Models,"</a>
                    2024 IEEE International Symposium on Local and Metropolitan Area Networks (LANMAN), 2024
                </li>
                <li style={{ marginLeft: '23px', textIndent: '-23px' }}><span style={{ display: 'inline', textAlign: 'left' }}>[4]:&nbsp;</span>
                    M. Geis, C. Bektas, S. Böcker, C. Wietfeld, <a
                        href={'https://cni.etit.tu-dortmund.de/newsdetail/automated-private-5g-network-planning-for-professional-industries-42792/'}
                        target={"_blank"} rel="noreferrer">"Automated Private 5G Network Planning for Professional Industries,"</a>
                    2024 IEEE International Symposium on Local and Metropolitan Area Networks (LANMAN), 2024
                </li>
                <li style={{ marginLeft: '23px', textIndent: '-23px' }}><span style={{ display: 'inline', textAlign: 'left' }}>[5]:&nbsp;</span>
                    3GPP, <a
                        href={'https://www.etsi.org/deliver/etsi_tr/138900_138999/138901/18.00.00_60/tr_138901v180000p.pdf'}
                        target={'_blank'} rel="noreferrer">"Study on channel model for frequencies from 0.5 to 100 GHz,”
                    </a> 3GPP TR 38.901 version 18.0.0 Release 18, 2024
                </li>
                <li style={{ marginLeft: '23px', textIndent: '-23px' }}><span style={{ display: 'inline', textAlign: 'left' }}>[6]:&nbsp;</span>
                    ITU, <a
                        href={'https://www.itu.int/dms_pubrec/itu-r/rec/p/R-REC-P.2040-3-202308-I!!PDF-E.pdf'}
                        target={'_blank'} rel="noreferrer">"Effects of building materials and structures on radiowave
                        propagation above about 100 MHz,”</a> Recommendation ITU-R P.2040-3, 2023
                </li>
            </ul>
        </div>
        <div id={"assumptions-text"} className={"ps-1 mb-2"}
            style={{ fontSize: "small", display: "none" }}>
            <div style={{ width: '105px' }}>Annahmen:<br /></div>
            <ul>
                <li>Kanalmodelle:
                    <ul>
                        <li>Empirisch (Starke Gebäudedämpfung): UMa LOS [5] + Obstacle Shadowing Concrete nach ITU-R P.2040-3 [6]</li>
                        <li>Empirisch (Mittlere Gebäudedämpfung): UMa LOS [5] + Obstacle Shadowing Brick nach ITU-R P.2040-3 [6]</li>
                        <li>Empirisch (Schwache Gebäudedämpfung): UMa LOS [5] + Obstacle Shadowing Plasterboard nach ITU-R P.2040-3 [6]</li>
                    </ul>
                </li>
                <li>Mögliche EIRPs: [0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 39, 40] dBm</li>
                <li>Mögliche Antennen: Rundstrahler, Gewinn 0 dBi</li>
                <li>Datenratenberechnung: L2-Datenrate +10% Overhead für obere Layer (vgl. [2])
                </li>
                <li>Grenzwert an der Grundstücksgrenze: Kein Grenzwert, aber Beschränkung auf 10W EIRP
                    Sendeleistung
                </li>
                <li>5G Konfiguration:
                    <ul>
                        <li>Layers = 2</li>
                        <li>Scaling Factor = 1</li>
                        <li>TDD Schema (D:U) = 2:1</li>
                        <li>Subcarrier Spacing = 30kHz (µ=1)</li>
                    </ul>
                </li>
                <li>Alle weiteren Annahmen und Parameter sind in den oben aufgeführten Veröffentlichungen zu finden
                </li>
            </ul>
        </div>
        <div id={"datasources-text"} className={"ps-1 mb-4"}
            style={{ fontSize: "small", display: "none" }}>
            <div style={{ width: '105px' }}>Umgebungsdaten:<br /></div>
            <ul>
                <li>
                    Flächenanteile gemäß <a href={"https://gdz.bkg.bund.de/index.php/default/wfs-corine-land-cover-5-ha-stand-2018-wfs-clc5-2018.html"}
                    className={"link"} target={"_blank"} rel={"noreferrer"}>
                    Bundesamt für Kartopraphie und Geodäsie</a>
                </li>
                <li>
                    Gebäudedaten auf Basis von <a href={"https://www.openstreetmap.org/"}
                    className={"link"} target={"_blank"} rel={"noreferrer"}>
                    OpenStreetMap</a>
                </li>
                <li>
                    Höhenprofil basierend auf <a href={"https://sdi.eea.europa.eu/catalogue/srv/eng/catalog.search#/metadata/d08852bc-7b5f-4835-a776-08362e2fbf4b"}
                    className={"link"} target={"_blank"} rel={"noreferrer"}>
                    European Digital Elevation Model (EU-DEM)</a>
                </li>
            </ul>
        </div>
    </div>)
}
export default ExampleCampus
